import { Segment } from 'component/Space/Segment'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { store } from 'store/store'

type Props = {
  value: string
  plus?: boolean
}

function formatHeight(value: string, unit: string, plus?: boolean): string {
  if (unit === 'in') {
    value = value.replace(/\d+/gi, x => Math.round(+x / 2.54).toFixed())
  }
  if (plus) {
    value = value.split('-')[0] + '+'
  }
  return value
}

export const Height = observer(({ value, plus }: Props) => {
  const { form, unit } = store.profile

  const onClick = useLatestCallback(() => {
    form.setHeightRange(value)
  })

  return <Segment active={form.heightRange === value} action={onClick}>
    {formatHeight(value, unit, plus)}
  </Segment>
})
